import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { colours } from './../helpers';

const Pages = [
  { route: '/acquisition', name: 'Acquisition' },
  { route: '/artifact-health', name: 'Artifact Health' },
  { route: '/artifact-regression', name: 'Artifact Regression' },
  { route: '/artifact-stats', name: 'Artifact Statistics' },
  { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
  { route: '/aws-instances-cost', name: 'AWS Instances Cost' },
  { route: '/axiom-ui', name: 'Axiom UI Tests' },
  { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' },
  { route: '/build', name: 'Build' },
  { route: '/build-health', name: 'Build Health' },
  { route: '/case-amending', name: 'Case Amending Tests' },
  { route: '/case-merging', name: 'Case Merging Tests' },
  { route: '/case-metrics', name: 'Case Metrics' },
  { route: '/cloud', name: 'Cloud' },
  { route: '/diff', name: 'Diff Tool Regression' },
  { route: '/engine-metrics', name: 'Engine Metrics' },
  { route: '/telemetry-examine', name: 'Examine' },
  { route: '/export-regression', name: 'Export Regression' },
  { route: '/installer', name: 'Installer Tests' },
  { route: '/jira-metrics', name: 'Jira Metrics' },
  { route: '/node-health', name: 'Node Health' },
  { route: '/performance', name: 'Performance Metrics' },
  { route: '/telemetry-process', name: 'Process' },
  { route: '/prtg', name: 'PRTG Status' },
  { route: '/release-metrics', name: 'Release Metrics' },
  { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
  { route: '/test-studio', name: 'Test Studio Tests' },
  { route: '/white', name: 'White Tests' },
];

const ProfileOptionsComponent = ({
  userConfiguration,
  submitOptions
}) => {
  let initTab = userConfiguration.customNav;
  if ( typeof userConfiguration.customNav === 'string' ) {
    initTab = JSON.parse(userConfiguration.customNav);
  }
  if (userConfiguration.customNav === 'null' || userConfiguration.customNav === null) {
    initTab = [
      {
        name: 'Build', options: [
          { route: '/build', name: 'Build' },
          { route: '/build-health', name: 'Build Health' },
          { route: '/node-health', name: 'Node Health' }
        ]
      },
      {
        name: 'Metrics', options: [
          { route: '/case-metrics', name: 'Case Metrics' },
          { route: '/engine-metrics', name: 'Engine Metrics' },
          { route: '/performance', name: 'Performance Metrics' },
          { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
          { route: '/artifact-stats', name: 'Artifact Statistics' },
          { route: '/jira-metrics', name: 'Jira Metrics' },
          { route: '/artifact-health', name: 'Artifact Health' },
          { route: '/release-metrics', name: 'Release Metrics' },
          { route: '/aws-instances-cost', name: 'AWS Instances Cost' }
        ]
      },
      {
        name: 'Regressions', options: [
          { route: '/white', name: 'White Tests' },
          { route: '/test-studio', name: 'Test Studio Tests' },
          { route: '/case-merging', name: 'Case Merging Tests' },
          { route: '/case-amending', name: 'Case Amending Tests' },
          { route: '/artifact-regression', name: 'Artifact Regression' },
          { route: '/diff', name: 'Diff Tool Regression' },
          { route: '/export-regression', name: 'Export Regression' },
          { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
          { route: '/installer', name: 'Installer Tests' },
          { route: '/axiom-ui', name: 'Axiom UI Tests' }
        ]
      },
      { route: '/cloud', name: 'Cloud' },
      { route: '/acquisition', name: 'Acquisition' },
      {
        name: 'Telemetry', options: [
          { route: '/telemetry-process', name: 'Process' },
          { route: '/telemetry-examine', name: 'Examine' },
          { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' }
        ]
      },
      { route: '/prtg', name: 'PRTG Status' },
    ];
  }
  const [tabs, setTabs] = useState(initTab);
  const darkMode = userConfiguration.darkMode;

  //buttons outside of columns

  function addSingle() {
    const copy = tabs.slice();
    copy.push(Pages[0]);
    setTabs(copy);
  }

  function addTab() {
    const copy = tabs.slice();
    copy.push({ name: 'New Tab', options: [] });
    setTabs(copy);
  }

  function resetToDef() {
    setTabs([
      {
        name: 'Build', options: [
          { route: '/build', name: 'Build' },
          { route: '/build-health', name: 'Build Health' },
          { route: '/node-health', name: 'Node Health' }
        ]
      },
      {
        name: 'Metrics', options: [
          { route: '/case-metrics', name: 'Case Metrics' },
          { route: '/engine-metrics', name: 'Engine Metrics' },
          { route: '/performance', name: 'Performance Metrics' },
          { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
          { route: '/artifact-stats', name: 'Artifact Statistics' },
          { route: '/jira-metrics', name: 'Jira Metrics' },
          { route: '/artifact-health', name: 'Artifact Health' },
          { route: '/release-metrics', name: 'Release Metrics' },
          { route: '/aws-instances-cost', name: 'AWS Instances Cost' }
        ]
      },
      {
        name: 'Regressions', options: [
          { route: '/white', name: 'White Tests' },
          { route: '/test-studio', name: 'Test Studio Tests' },
          { route: '/case-merging', name: 'Case Merging Tests' },
          { route: '/case-amending', name: 'Case Amending Tests' },
          { route: '/artifact-regression', name: 'Artifact Regression' },
          { route: '/diff', name: 'Diff Tool Regression' },
          { route: '/export-regression', name: 'Export Regression' },
          { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
          { route: '/installer', name: 'Installer Tests' },
          { route: '/axiom-ui', name: 'Axiom UI Tests' }
        ]
      },
      { route: '/cloud', name: 'Cloud' },
      { route: '/acquisition', name: 'Acquisition' },
      {
        name: 'Telemetry', options: [
          { route: '/telemetry-process', name: 'Process' },
          { route: '/telemetry-examine', name: 'Examine' },
          { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' }
        ]
      },
      { route: '/prtg', name: 'PRTG Status' },
    ]);
  }

  function clear() {
    setTabs([]);
  }

  function save() {
    userConfiguration.customNav = JSON.stringify(tabs);
    submitOptions(userConfiguration);
    window.location.reload(false);
  }

  //drawing columns

  const drawCol = (tabs) => tabs.map((tab, index) => {
    if (tab.route) {
      return (drawSingle(index));
    } else {
      return (drawDD(index));
    }
  });

  const drawSingle = (tabIndex) => {
    return (
      <div style={
        {
          background: 'lightgrey', borderWidth: '2px',
          borderColor: darkMode ? colours.colours.black : 'white', borderStyle: 'solid',
          width: '25%', display:'inline-block', padding: '5px',
          verticalAlign: 'top'
        }
      }
      >
        <button onClick={() => deleteTabItem(tabIndex)}
          style={{ color: 'red', float: 'right' }}
        >
          Delete
        </button>
        <h3 style={{ color: colours.colours.black }}>Single Link</h3>
        {singleLinkDD(tabIndex)}
      </div>
    );
  };

  const singleLinkDD = (tabIndex) => {
    return (
      <form>
        <div>
          <label style={{ color: colours.colours.black }}>
            <select value={tabs[tabIndex].name} onChange={pageChangeSL(tabIndex)}>
              {Pages.map(page => {
                return (<option key={page.name} value={page.name}>{page.name}</option>);
              })}
            </select>
          </label>
        </div>
      </form>
    );
  };

  const drawDD = (tabIndex) => {
    return (
      <div style={
        {
          background: 'lightgrey', borderWidth: '2px',
          borderColor: darkMode ? colours.colours.black : 'white', borderStyle: 'solid',
          width: '25%', display:'inline-block', padding: '5px',
          verticalAlign: 'top'
        }
      }
      >
        <button onClick={() => deleteTabItem(tabIndex)}
          style={{ color: 'red', float: 'right' }}
        >Delete</button>
        <h3 style={{ color: colours.colours.black }}>Dropdown</h3>
        <form style={{ color: colours.colours.black }}>
          <label>Tab Name:
            <input
              type="text"
              value={tabs[tabIndex].name}
              onChange={tabNameChange(tabIndex)}
            />
          </label>
        </form>
        <h3 style={{ color: colours.colours.black }}>Pages:</h3>
        {tabPages(tabs[tabIndex].options, tabIndex)}
        <button onClick={() => addPage(tabIndex)}
          style={{ color: colours.colours.black, float: 'right' }}
        >
          Add Page
        </button>
      </div>
    );
  };

  const tabPages = (pages, tabIndex) => pages.map((page, index) => {
    return (
      <div class="Row">
        <div class="col-md-10">
          {pageDropDown(page, index, tabIndex)}
        </div>
        <div class="col-md-2">
          <button onClick={() => deletePage(tabIndex, index)}
            style={{
              color: 'red', width: '25px',
              height: '25px'
            }}
          >x</button>
        </div>
      </div>
    );
  });

  const pageDropDown = (page, pageIndex, tabIndex) => {
    return (
      <form>
        <div>
          <label style={{ color: colours.colours.black }}>
            <select value={page.name}
              onChange={pageChangeDD(tabIndex, pageIndex)}
            >
              {Pages.map(page => {
                return (<option key={page.name} value={page.name}>{page.name}</option>);
              })}
            </select>
          </label>
        </div>
      </form>
    );
  };

  //modify column contents

  function deleteTabItem(index) {
    const copy = tabs.slice();
    copy.splice(index, 1);
    setTabs(copy);
  }

  function deletePage(tabIndex, pageIndex) {
    const copy = tabs.slice();
    copy[tabIndex].options.splice(pageIndex, 1);
    setTabs(copy);
  }

  function addPage(tabIndex) {
    const copy = tabs.slice();
    copy[tabIndex].options.push(Pages[0]);
    setTabs(copy);
  }

  const pageChangeSL = (tabIndex) => (event) => {
    let page;
    for (let i = 0; i < Pages.length; i++) {
      if (Pages[i].name === event.target.value) {
        page = Pages[i];
        break;
      }
    }
    const copy = tabs.slice();
    copy[tabIndex] = page;
    setTabs(copy);
  };

  const pageChangeDD = (tabIndex, pageIndex) => (event) => {
    let page;
    for (let i = 0; i < Pages.length; i++) {
      if (Pages[i].name === event.target.value) {
        page = Pages[i];
        break;
      }
    }
    const copy = tabs.slice();
    copy[tabIndex].options[pageIndex] = page;
    setTabs(copy);
  };

  const tabNameChange = (tabIndex) => (event) => {
    const copy = tabs.slice();
    copy[tabIndex].name = event.target.value;
    setTabs(copy);
  };

  return (
    <div>
      <div class="Row"> {/* Controls */}
        <button onClick={addSingle} style={{ color: colours.colours.black }}>
          Add Single Link</button>
        <button onClick={addTab} style={{ color: colours.colours.black }}>
          Add Column</button>
        <button onClick={resetToDef} style={{ color: colours.colours.black }}>
          Reset To Default</button>
        <br />
      </div>
      <div class="Row"> {/* Row of Tabs */}
        {drawCol(tabs)}
      </div>
      <button onClick={save}
        style={{ color: colours.colours.black }}
      >
        Save
      </button>
      <button onClick={clear}
        style={{ color: colours.colours.black }}
      >
        Clear
      </button>
    </div>
  );
};


ProfileOptionsComponent.propTypes = {
  userConfiguration: PropTypes.object.isRequired,
  submitOptions: PropTypes.func.isRequired
};

export default ProfileOptionsComponent;


// WEBPACK FOOTER //
// src/Components/CustomNavComponent.jsx